
export default {
	name: 'AboutPage',
	head ()
	{
		if (this.$route.path === '/') return {};

		const baseUrl = 'https://enifex.com';

		const breadcrumbData = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"name": "Home",
				"item": baseUrl
			},
			{
				"@type": "ListItem",
				"position": 2,
				"name": "About Us",
				"item": `${baseUrl}/about-us`
			}
			]
		};
		return {
			title: 'Enifex - About Us',
			link: [
				{
					rel: 'canonical',
					href: `https://www.enifex.com${this.$route.path}`
				}
			],
			script: [
				{
					hid: 'schema-about-breadcrumb',
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbData)
				}
			]
		};
	},
}
